module.exports = __webpack_public_path__ + "static/media/processometer-five.744e8ba5.png";